import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Puedo pagar con Cuenta RUT del Banco Estado?',
    a: 'Sí. Nuestra pasarela de pago acepta Cuenta RUT, débito y todas las tarjetas de crédito nacionales.'
  }, {
    q: '¿Es un libro físico?',
    a: 'No. Es 100% digital. Lo recibes en tu correo electrónico inmediatamente después del pago para que empieces esta misma noche.'
  }, {
    q: '¿Funciona si trabajo en turnos o en minería?',
    a: 'Sí. El Bonus 7 está diseñado específicamente para trabajadores de turno nocturno y rotación en faenas mineras.'
  }, {
    q: '¿Para quién es esto?',
    a: 'Para cualquier profesional, empleado o trabajador dependiente que se sienta agobiado por el ritmo laboral en Chile y quiera recuperar su energía y paz mental sin renunciar a su trabajo.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes 7 días de garantía total. Te devolvemos el 100% sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-20 bg-white" data-id="element-48">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-50">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-52">
              <button onClick={() => toggleFAQ(index)} className="w-full text-left px-6 py-5 flex items-center justify-between bg-white focus:outline-none" aria-expanded={openIndex === index} data-id="element-53">
                <span className="font-heading font-semibold text-lg text-navy pr-8" data-id="element-54">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-orange transform transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-57">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-100 pt-4" data-id="element-58">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}